import {setOrFallbackValue} from './helper';
import {Shipment, ShippingSummary} from './shipment';

class ShippingOption {
    constructor(props) {
        this.shipments = ('' === setOrFallbackValue(props, 'shipments', '')) ?
            [] : props.shipments.map((shipment) => {return new Shipment(shipment);});
        this.summary = ('' === setOrFallbackValue(props, 'summary', '')) ?
            null : new ShippingSummary(props.summary);
    }
}

export default ShippingOption;
